import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { GetProductsResponseMessage } from '../services/evergent/products/model/products-response-message.model';
import { ProductsService } from '../services/evergent/products/products.service';

@Injectable()
export class PlanResolver implements Resolve<GetProductsResponseMessage> {
  constructor(private readonly productService: ProductsService) {}

  resolve(): Observable<GetProductsResponseMessage> {
    return this.productService.getProducts();
  }
}
